import { useServiceClient } from 'bz-stores/hooks/service-client';
import type { OnlineUploadTempFileResponse, ResponseBase } from 'tm3-core/api.dtos';
import { OnlinePublicUploadTempFile } from 'tm3-core/api.dtos';

export const useUploadTempFile = () => {
  const client = useServiceClient();

  return async (file: File, folderId: string): Promise<string> => {
    const body = new FormData();
    body.append('id', folderId);
    body.append('file', file);

    const response = await client.postBody<ResponseBase<OnlineUploadTempFileResponse>>(
      new OnlinePublicUploadTempFile({ id: folderId }) as any,
      body
    );

    if (!response.result?.id) {
      throw new Error('Failed to upload temporary file.');
    }
    return response.result.id;
  };
};
